var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.value.title,
      "alerts": _vm.alerts,
      "breadCrumbs": _vm.breadCrumbs,
      "chips": _vm.chips,
      "actions": _vm.actions
    },
    on: {
      "actionClicked": function actionClicked($event) {
        return $event.exec();
      },
      "alertClicked": function alertClicked($event) {
        return $event.exec();
      }
    }
  }), _c('m-detail-view-grid', {
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('select-assignees', {
          attrs: {
            "css": "width: 100%",
            "partnerId": _vm.partner.id,
            "outlined": true,
            "dense": false
          },
          on: {
            "input": _vm.onAssigneesUpdate,
            "added": _vm.onAssigneesAdded,
            "removed": _vm.onAssigneesRemoved
          },
          model: {
            value: _vm.value.assignees,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "assignees", $$v);
            },
            expression: "value.assignees"
          }
        }), _c('shared-content-list', {
          ref: "sharedContentList",
          attrs: {
            "refId": _vm.value.id,
            "partnerId": _vm.value.partnerId,
            "title": _vm.$t('clearanceApproval.shared')
          },
          on: {
            "update:sharedContent": _vm.onSharedContentUpdate
          }
        }), _vm.value.seller && _vm.value.seller.ref ? _c('div', [_c('v-subheader', {
          staticClass: "mt-n2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.seller")) + " ")]), _c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('refs-invoice-party', {
          attrs: {
            "item": _vm.value.seller,
            "partnerId": _vm.value.partnerId
          },
          on: {
            "openDetail": function openDetail($event) {
              return _vm.openBuyerSellerSideCard(_vm.value.seller.ref);
            }
          },
          scopedSlots: _vm._u([_vm.value.seller.ref && _vm.value.seller.ref.refType ? {
            key: "icon",
            fn: function fn() {
              return [_c('v-icon', {
                staticClass: "ml-5 mr-4"
              }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.value.seller.ref.refType).icon) + " ")])];
            },
            proxy: true
          } : null], null, true)
        })], 1)], 1) : _vm._e(), _vm.value.buyer && _vm.value.buyer.ref ? _c('div', [_c('v-subheader', {
          staticClass: "mt-n2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.repairEstimate.buyer")) + " ")]), _c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('refs-invoice-party', {
          attrs: {
            "item": _vm.value.buyer,
            "partnerId": _vm.value.partnerId
          },
          on: {
            "openDetail": function openDetail($event) {
              return _vm.openBuyerSellerSideCard(_vm.value.buyer.ref);
            }
          },
          scopedSlots: _vm._u([_vm.value.buyer.ref && _vm.value.buyer.ref.refType ? {
            key: "icon",
            fn: function fn() {
              return [_c('v-icon', {
                staticClass: "ml-5 mr-4"
              }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.value.buyer.ref.refType).icon) + " ")])];
            },
            proxy: true
          } : null], null, true)
        })], 1)], 1) : _vm._e(), _c('div', {
          staticClass: "mt-4"
        }), _vm.value.estimateId ? _c('select-entity', {
          staticClass: "mt-2 mb-n2",
          attrs: {
            "refType": _vm.ResourceEnum.REPAIR_ESTIMATE,
            "partnerId": _vm.value.partnerId,
            "label": _vm.$t('objects.clearance.estimateId'),
            "hint": _vm.$t('objects.clearance.estimateIdHint'),
            "clearable": !_vm.value.isCompleted,
            "disabled": _vm.value.isCompleted
          },
          on: {
            "input": function input($event) {
              return _vm.value.updatePartial({
                estimateId: $event || null
              });
            }
          },
          model: {
            value: _vm.value.estimateId,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "estimateId", $$v);
            },
            expression: "value.estimateId"
          }
        }) : _vm._e(), _vm.value.reportId ? _c('select-entity', {
          staticClass: "mt-2 mb-n2",
          attrs: {
            "refType": _vm.ResourceEnum.REPORT,
            "partnerId": _vm.value.partnerId,
            "label": _vm.$t('objects.repairEstimate.reportId'),
            "hint": _vm.$t('objects.repairEstimate.reportIdHint'),
            "clearable": !_vm.value.isCompleted,
            "disabled": _vm.value.isCompleted
          },
          on: {
            "input": _vm.updateReport
          },
          model: {
            value: _vm.value.reportId,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "reportId", $$v);
            },
            expression: "value.reportId"
          }
        }) : _vm._e(), _vm.value.report && _vm.value.report.vehicle ? _c('div', {
          staticClass: "mt-n8"
        }, [_c('v-subheader', {
          staticClass: "mt-n2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("common.nouns.vehicle")) + " ")]), _c('v-card', {
          attrs: {
            "outlined": ""
          }
        }, [_c('refs-vehicle', {
          key: _vm.value.report.vehicleId + 'refs-report-clearance',
          attrs: {
            "item": _vm.value.report.vehicle
          },
          on: {
            "openDetail": function openDetail($event) {
              _vm.value.report.vehicle.goTo(_vm.$router).detail();
            }
          },
          scopedSlots: _vm._u([{
            key: "icon",
            fn: function fn() {
              return [_c('v-icon', {
                staticClass: "ml-5 mr-4"
              }, [_vm._v(" " + _vm._s(_vm.RefTypeMap.get(_vm.ResourceEnum.VEHICLE).icon) + " ")])];
            },
            proxy: true
          }], null, false, 1337751523)
        })], 1)], 1) : _vm._e(), _vm.refsCategories.length ? _c('div', [_c('v-subheader', {
          staticClass: "mt-2 mb-n2"
        }, [_vm._v(" " + _vm._s(_vm.$t("objects.clearanceApproval.refs")) + " ")]), _c('refs-select', {
          ref: "refsSelect",
          attrs: {
            "partnerId": _vm.value.partnerId,
            "loading": _vm.isLoadingRefs,
            "suggested": [],
            "listMode": false,
            "hideEditButton": false,
            "categories": _vm.refsCategories,
            "hideSuggestions": true,
            "confirmable": false
          },
          on: {
            "confirm": _vm.saveRefs,
            "change": _vm.saveRefs,
            "input": _vm.saveRefs
          },
          model: {
            value: _vm.value.refs,
            callback: function callback($$v) {
              _vm.$set(_vm.value, "refs", $$v);
            },
            expression: "value.refs"
          }
        })], 1) : _vm._e(), _c('v-divider', {
          staticClass: "mt-6"
        }), _c('m-action-list', {
          attrs: {
            "actions": _vm.bottomActions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        })];
      },
      proxy: true
    }])
  }, [_c('v-card', {
    staticClass: "mb-4",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("objects.report.repair.title")) + " ")]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_vm.value.repairStartFormable ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.clearance.repairStart'),
      "type": "date",
      "readonly": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.value.repairStartFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "repairStartFormable", $$v);
      },
      expression: "value.repairStartFormable"
    }
  }) : _c('m-text-field', {
    attrs: {
      "value": "-",
      "label": _vm.$t('objects.clearance.repairStart'),
      "readonly": "",
      "hide-details": "auto"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_vm.value.repairEndFormable ? _c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.clearance.repairEnd'),
      "hint": _vm.$t('objects.clearance.repairEnd'),
      "type": "date",
      "readonly": "",
      "hide-details": "auto",
      "persistent-hint": ""
    },
    model: {
      value: _vm.value.repairEndFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "repairEndFormable", $$v);
      },
      expression: "value.repairEndFormable"
    }
  }) : _c('m-text-field', {
    attrs: {
      "value": "-",
      "label": _vm.$t('objects.report.repair.endDate'),
      "readonly": "",
      "hide-details": "auto"
    }
  })], 1), _vm.value.periodInDays ? _c('v-col', {
    attrs: {
      "cols": "6",
      "sm": "4"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.repair.periodInDays'),
      "readonly": "",
      "hide-details": ""
    },
    model: {
      value: _vm.value.periodInDays,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "periodInDays", $$v);
      },
      expression: "value.periodInDays"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _c('clearance-detail-form', {
    staticClass: "my-4",
    attrs: {
      "value": _vm.value
    }
  }), _vm.value.isCompleted ? _c('v-card', {
    staticClass: "my-4",
    attrs: {
      "outlined": ""
    }
  }, [!_vm.mapToImage.length ? _c('m-no-content', {
    attrs: {
      "icon": "mdi-camera-off",
      "text": _vm.$t('components.PartnerReportDetail.damage.missingImages')
    }
  }) : _vm._e(), _vm.mapToImage.length ? _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.ClearanceResponseCard.completionImages")) + " ")]) : _vm._e(), _vm.mapToImage.length ? _c('v-card-text', [_c('vue-picture-swipe', {
    ref: "pictureSwipe",
    attrs: {
      "items": _vm.mapToImage,
      "options": {
        shareEl: false,
        rotationOn: true
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm.canReadRepairEstimate ? _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "outlined": ""
    }
  }, [!_vm.value.costExtensionEstimateId ? _c('m-no-content', {
    attrs: {
      "text": _vm.$t('clearance.noCostExtension'),
      "icon": "mdi-finance"
    }
  }) : _vm.value.isCostExtensionEstimateLoading ? _c('v-card-text', [_c('v-skeleton-loader', {
    attrs: {
      "width": "100%",
      "type": "article, list-item-two-line, list-item-two-line,list-item-two-line, list-item-two-line"
    }
  })], 1) : _c('v-card-text', [_c('v-sheet', {
    staticClass: "pa-4",
    attrs: {
      "rounded": "",
      "color": "grey lighten-4"
    }
  }, [_c('repair-estimate-sheet', {
    attrs: {
      "estimate": _vm.value.costExtensionEstimate,
      "report": _vm.value.report,
      "hideSharingLink": ""
    }
  })], 1)], 1)], 1) : _vm._e(), _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('clearance-detail-clearance-approval-card', {
    attrs: {
      "value": _vm.value,
      "report": _vm.value.report
    }
  })], 1)], 1), _c('activity-card', {
    attrs: {
      "partner": _vm.partner,
      "source": _vm.source,
      "config": {
        comment: true,
        mail: false
      }
    }
  })], 1), _vm.isDeleteDialogActive && _vm.value ? _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDeleteDialogActive,
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "title": _vm.$t('partner.PartnerReportDetailChangeProgress.confirmDeleteTitle'),
      "rightColor": 'error',
      "loading": _vm.isDeleteLoading,
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isDeleteDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialogActive = false;
      },
      "rightClick": _vm.onDelete
    }
  }) : _vm._e(), _vm.personSideCard ? _c('person-side-card', {
    attrs: {
      "value": _vm.personSideCard
    },
    on: {
      "close": function close($event) {
        _vm.personSideCard = null;
      }
    }
  }) : _vm._e(), _vm.companySideCard ? _c('company-side-card', {
    attrs: {
      "value": _vm.companySideCard
    },
    on: {
      "close": function close($event) {
        _vm.companySideCard = null;
      }
    }
  }) : _vm._e(), _c('template-dialog', {
    ref: "replyToInformationRequestDialog",
    attrs: {
      "hideButton": true,
      "from": [_vm.partner],
      "to": _vm.to,
      "refs": [{
        refId: _vm.value.id,
        refType: _vm.ResourceEnum.CLEARANCE_APPROVAL
      }],
      "context": _vm.context,
      "attachmentFileFilters": _vm.attachmentFileFilters
    },
    on: {
      "sent": _vm.resetStateBackToRequested
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }